const SvgIcon = ({ size= '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <g
      stroke="none"
      transform="translate(-1.091 -1.091)scale(1.09142)"
    >
      <path
        fill={color}
        stroke="none"
        d="M7.5 6C6.683 6 6 6.683 6 7.5S6.683 9 7.5 9 9 8.317 9 7.5 8.317 6 7.5 6m0 1c.264 0 .5.236.5.5s-.236.5-.5.5a.516.516 0 0 1-.5-.5c0-.264.236-.5.5-.5m.5.5a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5.5.5 0 0 1 .5.5M4 1C2.355 1 1 2.355 1 4v7.172c0 .795.317 1.559.879 2.121l8.703 8.705.004.002a3.44 3.44 0 0 0 4.828 0l.004-.002 6.58-6.58.002-.004a3.44 3.44 0 0 0 0-4.828l-.002-.004-8.705-8.703A3 3 0 0 0 11.172 1Zm0 2h7.172c.265 0 .52.105.707.293l8.703 8.705a1.41 1.41 0 0 1-.002 2.008l-6.578 6.576a1.41 1.41 0 0 1-2.008-.002l-8.701-8.701A1 1 0 0 1 3 11.172V4c0-.564.436-1 1-1"
      ></path>
    </g>
  </svg>
);

export default SvgIcon;

